import { Component, Input, forwardRef } from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-reusable-checkbox',
  standalone: true,
  imports: [],
  template: `
    <label class="inline-flex items-center gap-2 cursor-pointer">
      <input
        type="checkbox"
        [checked]="value"
        [disabled]="disabled"
        (change)="onChangeHandler($event)"
        (blur)="onTouched()"
        class="w-4 h-4 rounded border-slate200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        style="accent-color: #6366f1;"
        />
      @if (label) {
        <span>{{ label }}</span>
      }
    </label>
    `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReusableCheckbox),
      multi: true
    }
  ]
})
export class ReusableCheckbox implements ControlValueAccessor {

  @Input() label: string = '';
  @Input() disabled = false;

  value: boolean = false;

  private onChange = (value: boolean) => {};
  public onTouched = () => {};

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChangeHandler(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.checked;
    this.onChange(this.value);
  }
}
